import React from 'react'

//Components
import { CheckmarkIcon } from 'components/SASIcon'

//Styles
import styles from './Checkbox.module.scss'

interface Props {
  id: string,
  checked?: boolean,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>)=>void,
  label: any,
  title?: string,
  ellipseText?: boolean
}

const Checkbox = ({id, checked, onChange, label, title, ellipseText }: Props) => {
  return (
    <div className={`${styles.field} ${ellipseText ? styles.ellipse : ''}`} title={title}>
      <input type="checkbox" id={id+'-checkbox'} className={styles.checkbox} checked={checked} onChange={onChange} value={id} />
      {checked ? <CheckmarkIcon /> : <></>}
      <label className={styles.label} htmlFor={id+'-checkbox'}>{label}</label>
    </div> 
  )
}

export default Checkbox